module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1522-07c1bd22ca5bea8867a4d6471c9a6b7a.png";